<template>
  <div class="altcraft__actions--push">
    <button
      class="button button-main altcraft__button"
      @click="subPush">
      Turn on notifications
    </button>

    <button
      class="button"
      @click="closePush">
      Maybe later
    </button>
  </div>
</template>

<script>
export default {
  name: 'AltcraftPopupPush',

  methods: {
    subPush() {
      this.$emit('subPush');
    },

    closePush() {
      this.$emit('close', 'denied');
    },
  },
};
</script>

<style lang="scss" scoped>
  .altcraft__actions.altcraft__actions--push {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .altcraft__button {
    padding: 12px;
    margin-right: 8px;
  }

  @media screen and #{$screen-more-or-640} {
    .altcraft__actions.altcraft__actions--push {
      display: flex;
    }
  }
</style>
